import { withStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';

export default withStyles({
  root: {
    width: '100%',
  },
})(Tabs);
